// Home feed: FeedPage + home-feed components.
export const feed: Record<string, string> = {
  // FeedPage
  'Share a trade idea… (BTCUSD, EURUSD, SPY…)': 'Podeli trejd ideju… (BTCUSD, EURUSD, SPY…)',
  'Failed to load feed': 'Učitavanje feed-a nije uspelo',
  'Failed to load trades': 'Učitavanje trejdova nije uspelo',
  'Retry': 'Pokušaj ponovo',
  'No trades from followed traders': 'Nema trejdova od trejdera koje pratiš',
  'No personalized trades yet': 'Još nema personalizovanih trejdova',
  'No trade ideas yet': 'Još nema trejd ideja',
  'Follow traders to see their ideas here.': 'Zaprati trejdere da ovde vidiš njihove ideje.',
  'Interact with posts to personalize your feed.': 'Interaguj sa objavama da personalizuješ svoj feed.',
  'Be the first to post a trade idea, or adjust your filters.': 'Budi prvi koji će objaviti trejd ideju, ili prilagodi filtere.',
  'Clear Filters': 'Poništi filtere',
  'Sample trade ideas — be the first to post a real one!': 'Primeri trejd ideja — budi prvi koji će objaviti pravu!',
  'Load more': 'Učitaj još',
  'Post a trade idea to get started': 'Objavi trejd ideju za početak',
  "You've reached the end of the feed": 'Stigao si do kraja feed-a',
  'Refresh feed': 'Osveži feed',

  // FeedFilterBar
  'Newest': 'Najnovije',
  'Trending': 'U trendu',
  'Most Liked': 'Najviše sviđanja',
  'All Ideas': 'Sve ideje',
  'For You': 'Za tebe',
  'Top Rated': 'Najbolje ocenjene',
  'Verified': 'Verifikovani',
  'Closed Trades': 'Zatvoreni trejdovi',
  'Search ticker…': 'Pretraži tiker…',
  'Search ticker, trader…': 'Pretraži tiker, trejdera…',
  'Filter': 'Filter',
  'Market': 'Tržište',
  'Timeframe': 'Vremenski okvir',
  'Direction': 'Smer',
  'Sort By': 'Sortiraj po',
  'All': 'Sve',
  'Post type': 'Vrsta objave',
  'Clear all filters': 'Poništi sve filtere',

  // FeedLeftSidebar
  'Expand sidebar': 'Proširi bočnu traku',
  'Collapse sidebar': 'Skupi bočnu traku',
  'Feed': 'Feed',
  'REMINDER': 'PODSETNIK',
  'Signals are not investment advice. Only trade money you can afford to lose.':
    'Signali nisu investicioni savet. Trguj samo novcem koji smeš da izgubiš.',

  // HowItWorksModal
  'How ShowMeTrade Works': 'Kako ShowMeTrade funkcioniše',
  'Transparent trading performance, publicly tracked': 'Transparentni trejding rezultati, javno praćeni',
  'Post your chart': 'Objavi svoj grafikon',
  'Share your trade idea with Entry, Stop Loss and Take Profit levels. Upload a chart screenshot or let us auto-generate a chart from your levels.': 'Podeli svoju trejd ideju sa Entry, Stop Loss i Take Profit nivoima. Otpremi screenshot grafikona ili pusti da automatski generišemo grafikon iz tvojih nivoa.',
  'System tracks your trade': 'Sistem prati tvoj trejd',
  'ShowMeTrade automatically monitors your trade in real-time. When price hits your TP or SL, your result is recorded publicly — no editing allowed.': 'ShowMeTrade automatski prati tvoj trejd u realnom vremenu. Kada cena dostigne tvoj TP ili SL, rezultat se javno beleži — izmene nisu dozvoljene.',
  'Get ranked by real performance': 'Rangiraj se po stvarnim rezultatima',
  'Your win rate, R:R ratio, and consistency score are calculated from actual closed trades — not followers or likes. Earn badges and climb the leaderboard.': 'Tvoj win rate, R:R odnos i skor konzistentnosti računaju se iz stvarno zatvorenih trejdova — ne iz pratilaca ili sviđanja. Osvajaj bedževe i penji se na rang listi.',
  'Step': 'Korak',
  'Credibility is earned, not bought.': 'Kredibilitet se zarađuje, ne kupuje.',
  'Every badge and ranking is based on verified closed trades.': 'Svaki bedž i rang zasnovani su na verifikovanim zatvorenim trejdovima.',
  "Got it — let's trade": 'Razumem — idemo da trejdujemo',

  // CommentImageParts
  'Attach a chart screenshot': 'Priloži screenshot grafikona',
  'Attached chart': 'Priloženi grafikon',
  'Uploading…': 'Otpremanje…',
  'Remove image': 'Ukloni sliku',
  'Open chart image': 'Otvori sliku grafikona',
  'Chart attachment': 'Prilog grafikona',

  // LiveTradeChart
  'Chart under review for this signal.': 'Grafikon je na proveri za ovaj signal.',
  'Chart data temporarily unavailable.': 'Podaci grafikona trenutno nisu dostupni.',
  'LIVE': 'UŽIVO',
  'Replay speed': 'Brzina reprodukcije',
  'Restart replay': 'Ponovo pokreni replay',
  'Pause': 'Pauza',
  'Resume': 'Nastavi',
  'Play': 'Pusti',
  'Loading live chart…': 'Učitavanje grafikona uživo…',

  // SignalChartPlayer
  'No chart': 'Nema grafikona',
  'Play replay': 'Pusti replay',

  // PositionChart
  'Loading chart…': 'Učitavanje grafikona…',
  'Drag to move': 'Prevuci da pomeriš',

  // NewTradeForm + TradePostModal (form, validation, toasts)
  'Image must be under 5MB': 'Slika mora biti manja od 5MB',
  'Image too small — charts must be at least 400×200px': 'Slika je premala — grafikoni moraju biti najmanje 400×200px',
  'Your image is': 'Tvoja slika je',
  'Only chart screenshots allowed': 'Dozvoljeni su samo screenshot-ovi grafikona',
  'Upload a landscape screenshot from TradingView or your trading platform. Portrait/square images are not accepted.': 'Otpremi horizontalni screenshot sa TradingView-a ili svoje trejding platforme. Uspravne/kvadratne slike se ne prihvataju.',
  'Image is too wide — upload a standard chart screenshot': 'Slika je preširoka — otpremi standardni screenshot grafikona',
  'Aspect ratio is too extreme:': 'Odnos stranica je previše ekstreman:',
  'Could not read image — try a different file': 'Slika ne može da se pročita — probaj drugi fajl',
  'Please sign in to post a trade idea': 'Prijavi se da objaviš trejd ideju',
  'Chart screenshots only': 'Samo screenshot-ovi grafikona',
  'Upload a landscape chart screenshot from your trading platform.': 'Otpremi horizontalni screenshot grafikona sa svoje trejding platforme.',
  'Image upload failed': 'Otpremanje slike nije uspelo',
  'Failed to post trade': 'Objavljivanje trejda nije uspelo',
  'Trade idea posted!': 'Trejd ideja objavljena!',
  'live in the feed': 'uživo u feed-u',
  'Network error — please try again': 'Greška na mreži — pokušaj ponovo',
  'Share Your Trade Setup': 'Podeli svoj trejd setup',
  'Join thousands of traders sharing real-time setups, entries, and analysis.': 'Pridruži se hiljadama trejdera koji dele setup-ove, entry-je i analize u realnom vremenu.',
  'Get Started': 'Započni',
  'Post a trade idea… (BTCUSD, EURUSD, SPY…)': 'Objavi trejd ideju… (BTCUSD, EURUSD, SPY…)',
  'New Trade Idea': 'Nova trejd ideja',
  'TICKER': 'TIKER',
  'DIRECTION': 'SMER',
  'MARKET': 'TRŽIŠTE',
  'TIMEFRAME': 'VREMENSKI OKVIR',
  'ORDER TYPE': 'TIP NALOGA',
  'POSITION SIZE': 'VELIČINA POZICIJE',
  'ANALYSIS / CAPTION': 'ANALIZA / OPIS',
  'CHART SCREENSHOT': 'SCREENSHOT GRAFIKONA',
  'Ticker is required': 'Tiker je obavezan',
  'Max 12 characters': 'Najviše 12 karaktera',
  'Max 12 chars': 'Najviše 12 karaktera',
  'Letters and numbers only': 'Samo slova i brojevi',
  'Required': 'Obavezno',
  'Invalid price': 'Nevažeća cena',
  'Invalid': 'Nevažeće',
  'Must be > 0': 'Mora biti > 0',
  'SL below entry': 'SL mora biti ispod entry-ja',
  'SL above entry': 'SL mora biti iznad entry-ja',
  'TP above entry': 'TP mora biti iznad entry-ja',
  'TP below entry': 'TP mora biti ispod entry-ja',
  'Max 1000 characters': 'Najviše 1000 karaktera',
  'Fills now at market price.': 'Izvršava se odmah po tržišnoj ceni.',
  'Rests until price reaches your trigger.': 'Čeka dok cena ne dostigne tvoj trigger.',
  'Risk %': 'Rizik %',
  '% of demo balance risked if SL is hit.': '% demo balansa koji rizikuješ ako SL bude pogođen.',
  '% of demo balance risked at SL.': '% demo balansa koji rizikuješ na SL.',
  'Fixed position size (units).': 'Fiksna veličina pozicije (jedinice).',
  'Describe your setup — key levels, confluence, entry trigger, market structure…': 'Opiši svoj setup — ključni nivoi, konfluencija, entry okidač, struktura tržišta…',
  'Chart preview': 'Pregled grafikona',
  'Upload chart screenshot': 'Otpremi screenshot grafikona',
  'TradingView, MT4/MT5, or any trading platform screenshot. Landscape only · PNG, JPG · max 5MB': 'Screenshot sa TradingView-a, MT4/MT5 ili bilo koje trejding platforme. Samo horizontalno · PNG, JPG · najviše 5MB',
  'No photos — charts only': 'Bez fotografija — samo grafikoni',
  'Posting…': 'Objavljivanje…',
  'Post Trade Idea': 'Objavi trejd ideju',

  // TradePostModal only
  'Unsupported file format — please use JPG, JPEG, PNG, or WebP': 'Nepodržan format fajla — koristi JPG, JPEG, PNG ili WebP',
  'Image exceeds maximum file size of 10MB': 'Slika prelazi maksimalnu veličinu fajla od 10MB',
  'Please upload a chart image with your trade idea. Stock photos and generic images are not allowed.': 'Otpremi sliku grafikona uz svoju trejd ideju. Stok fotografije i generičke slike nisu dozvoljene.',
  'Please drop an image file': 'Ubaci fajl slike',
  'Failed to upload image': 'Otpremanje slike nije uspelo',
  'Upload succeeded but no URL was returned': 'Otpremanje je uspelo, ali URL nije vraćen',
  'Please confirm your image is a chart, or upload a proper chart screenshot.': 'Potvrdi da je tvoja slika grafikon, ili otpremi pravi screenshot grafikona.',
  'What are you posting?': 'Šta objavljuješ?',
  'Signal': 'Signal',
  'Analysis': 'Analiza',
  'Entry · SL · TP — settles & counts': 'Entry · SL · TP — poravnava se i računa',
  'Chart + thesis — not counted': 'Grafikon + teza — ne računa se',
  'Trade Setup': 'Trejd setup',
  'Draw your position': 'Nacrtaj svoju poziciju',
  'Drag the': 'Prevuci',
  'target': 'target',
  'entry': 'entry',
  'stop': 'stop',
  'lines — or type exact values below.': 'linije — ili unesi tačne vrednosti ispod.',
  'Order & Size': 'Nalog i veličina',
  'Price Levels': 'Nivoi cena',
  'Risk/Reward:': 'Rizik/dobit:',
  'Good setup': 'Dobar setup',
  'TP2 price': 'TP2 cena',
  'TP3 price': 'TP3 cena',
  'Chart Image': 'Slika grafikona',
  'Chart screenshot (optional)': 'Screenshot grafikona (opciono)',
  'Auto-chart will be generated': 'Grafikon će biti automatski generisan',
  'Auto-chart from your levels': 'Auto-grafikon iz tvojih nivoa',
  'Paste (Ctrl+V) or upload a screenshot from your platform. If you skip it, the chart is drawn from your entry, SL and TP — red = risk, blue = reward.': 'Nalepi (Ctrl+V) ili otpremi screenshot sa svoje platforme. Ako preskočiš, grafikon se crta iz tvog entry-ja, SL-a i TP-a — crveno = rizik, plavo = dobit.',
  'No market data for': 'Nema tržišnih podataka za',
  'position drawn from your levels': 'pozicija nacrtana iz tvojih nivoa',
  'Enter entry, SL and TP below to preview your position.': 'Unesi entry, SL i TP ispod da vidiš pregled pozicije.',
  'Chart images only.': 'Samo slike grafikona.',
  'Upload a chart screenshot from your trading platform, a candlestick chart, or an annotated setup. Non-chart images will be rejected. If no image is uploaded, a chart is auto-generated from your trade levels.': 'Otpremi screenshot grafikona sa svoje trejding platforme, candlestick grafikon ili anotirani setup. Slike koje nisu grafikoni biće odbijene. Ako slika nije otpremljena, grafikon se automatski generiše iz tvojih trejd nivoa.',
  'Paste (Ctrl/Cmd+V), drop, or': 'Nalepi (Ctrl/Cmd+V), prevuci, ili',
  'I confirm this is a chart image — my post may be flagged for review': 'Potvrđujem da je ovo slika grafikona — moja objava može biti označena za proveru',
  'Chart ready': 'Grafikon spreman',
  'Drop chart screenshot here': 'Ubaci screenshot grafikona ovde',
  'browse files': 'izaberi fajlove',
  'Candlestick charts · Annotated setups only': 'Samo candlestick grafikoni · anotirani setup-ovi',
  'Validating image…': 'Provera slike…',
  'Analysis / Caption': 'Analiza / Opis',
  'Describe your trade setup, key levels, and reasoning…': 'Opiši svoj trejd setup, ključne nivoe i obrazloženje…',
  'Share as signal after publishing': 'Podeli kao signal nakon objave',
  'Open the share sheet with a branded card + your referral link': 'Otvara deljenje sa brendiranom karticom + tvojim referalnim linkom',

  // TradeCard
  'Now following': 'Sada pratiš',
  'Unfollowed': 'Otpratio si',
  'Please sign in to follow traders': 'Prijavi se da zapratiš trejdere',
  'Failed to update follow status': 'Ažuriranje praćenja nije uspelo',
  'Network error': 'Greška na mreži',
  'Removed from saved': 'Uklonjeno iz sačuvanog',
  'Saved to collection': 'Sačuvano u kolekciju',
  'Link copied': 'Link kopiran',
  'Trade deleted': 'Trejd obrisan',
  'Failed to delete trade': 'Brisanje trejda nije uspelo',
  'Reply posted': 'Odgovor objavljen',
  'Comment posted': 'Komentar objavljen',
  'Failed to post comment': 'Objavljivanje komentara nije uspelo',
  'Network error. Please try again.': 'Greška na mreži. Pokušaj ponovo.',
  'AI Analysis': 'AI analiza',
  'AI-generated': 'AI generisano',
  'Setup has warnings': 'Setup ima upozorenja',
  '{time} ago': 'pre {time}',
  'Powered by AI': 'Pokreće AI',
  'Reply': 'Odgovori',
  'reply': 'odgovor',
  'replies': 'odgovora',
  'Edit caption': 'Izmeni opis',
  'Delete trade': 'Obriši trejd',
  'Copy link': 'Kopiraj link',
  'Edited': 'Izmenjeno',
  'edited': 'izmenjeno',
  'OPEN': 'OTVOREN',
  'HIT TP': 'TP POGOĐEN',
  'HIT SL': 'SL POGOĐEN',
  'CLOSED': 'ZATVOREN',
  'PENDING': 'NA ČEKANJU',
  'NOT TRIGGERED': 'NIJE AKTIVIRAN',
  'Pending — activates at': 'Na čekanju — aktivira se na',
  'Order activates (fills) at this price': 'Nalog se aktivira (izvršava) po ovoj ceni',
  'Entry = market price at the moment the idea was posted': 'Entry = tržišna cena u trenutku objave ideje',
  'Entry price': 'Entry cena',
  'like': 'sviđanje',
  'likes': 'sviđanja',
  '... more': '... više',
  'View Idea': 'Pogledaj ideju',
  'Replying to': 'Odgovaraš korisniku',
  'Reply to': 'Odgovori korisniku',
  'Add your analysis…': 'Dodaj svoju analizu…',
  'No comments yet. Share your analysis.': 'Još nema komentara. Podeli svoju analizu.',
  'Delete Trade?': 'Obrisati trejd?',
  'This will permanently delete your': 'Ovo će trajno obrisati tvoju',
  'trade idea.': 'trejd ideju.',
  'Deleting…': 'Brisanje…',

  // TradeDetailModal
  'R:R Breakdown': 'R:R pregled',
  'Risk': 'Rizik',
  'Reward': 'Dobit',
  'Best R:R': 'Najbolji R:R',
  'Entry / Exit Signals': 'Entry / Exit signali',
  'Entry Zone': 'Entry zona',
  'Invalidation': 'Invalidacija',
  'Target 1': 'Cilj 1',
  'Target 2': 'Cilj 2',
  'Target 3': 'Cilj 3',
  'Closed at': 'Zatvoreno na',
  'Comments': 'Komentari',
  'No comments yet. Be the first to share your analysis.': 'Još nema komentara. Budi prvi koji će podeliti analizu.',
  'View original analysis': 'Pogledaj originalnu analizu',
  'Posted': 'Objavljeno',

  // TradeEditModal
  'Failed to update analysis': 'Ažuriranje analize nije uspelo',
  'Analysis updated': 'Analiza ažurirana',
  'Edit Analysis': 'Izmeni analizu',
  "Locked — verified entry, can't be changed": 'Zaključano — verifikovan unos, ne može se menjati',
  'Ticker': 'Tiker',
  'CAPTION / COMMENTARY': 'OPIS / KOMENTAR',
  'Update your thesis or commentary…': 'Ažuriraj svoju tezu ili komentar…',
  'You can refine the write-up anytime. Edited posts show an “edited” label for transparency.': 'Opis možeš doraditi bilo kada. Izmenjene objave imaju oznaku „izmenjeno“ radi transparentnosti.',
  'Saving…': 'Čuvanje…',
  'Save Changes': 'Sačuvaj izmene',

  // Transparent SL/TP updates (TradeEditModal, ideas/[id], TradeCard)
  'Edit signal': 'Izmeni signal',
  'Edit SL/TP': 'Izmeni SL/TP',
  'LEVELS (live signal — changes are public)': 'NIVOI (signal uživo — izmene su javne)',
  'optional': 'opciono',
  'Reason for the change (optional, shown publicly)': 'Razlog izmene (opciono, javno vidljivo)',
  'Every SL/TP change is recorded with the old and new value and shown publicly on the signal. Entry, direction and ticker stay locked.':
    'Svaka izmena SL/TP se beleži sa starom i novom vrednošću i javno prikazuje na signalu. Entry, smer i tiker ostaju zaključani.',
  'Levels updated — the change is now visible in the signal history': 'Nivoi ažurirani — izmena je sada vidljiva u istoriji signala',
  'Enter valid Stop Loss and Take Profit 1 prices': 'Unesi ispravne cene za Stop Loss i Take Profit 1',
  'For a LONG the Stop Loss must be below and every Take Profit above the entry': 'Za LONG Stop Loss mora biti ispod, a svaki Take Profit iznad entry-ja',
  'For a SHORT the Stop Loss must be above and every Take Profit below the entry': 'Za SHORT Stop Loss mora biti iznad, a svaki Take Profit ispod entry-ja',
  'Failed to update signal': 'Izmena signala nije uspela',
  'Entry locked · SL/TP changes are recorded publicly': 'Entry je zaključan · izmene SL/TP se javno beleže',
  'Change history': 'Istorija izmena',
  'every SL/TP change is public and applies only from the moment it was made': 'svaka izmena SL/TP je javna i važi tek od trenutka kada je napravljena',
  'No reason given': 'Bez navedenog razloga',
  'SL/TP changed': 'izmena SL/TP',
  'SL/TP were changed after publishing — every change is public on the signal page': 'SL/TP su menjani posle objave — svaka izmena je javna na strani signala',
  // Server-side (update_trade_levels) validation messages, translated when surfaced in a toast
  'Levels can only be updated while the signal is live (OPEN or PENDING)': 'Nivoi se mogu menjati samo dok je signal aktivan (OPEN ili PENDING)',
  'For a LONG the Stop Loss must be below the entry': 'Za LONG Stop Loss mora biti ispod entry-ja',
  'For a LONG every Take Profit must be above the entry': 'Za LONG svaki Take Profit mora biti iznad entry-ja',
  'For a SHORT the Stop Loss must be above the entry': 'Za SHORT Stop Loss mora biti iznad entry-ja',
  'For a SHORT every Take Profit must be below the entry': 'Za SHORT svaki Take Profit mora biti ispod entry-ja',
  'Stop Loss and Take Profit 1 are required': 'Stop Loss i Take Profit 1 su obavezni',
  'Nothing changed': 'Ništa nije promenjeno',

  // TrendingSidebar
  'No traders yet': 'Još nema trejdera',
  'Post a signal to show up here.': 'Objavi signal da se pojaviš ovde.',
  'trades': 'trejdova',
  'Trending Tickers': 'Tikeri u trendu',
  'Live': 'Uživo',
  'Not enough activity yet': 'Još nema dovoljno aktivnosti',
  'The most-traded tickers appear as trades come in.': 'Najtrgovaniji tikeri se pojavljuju kako trejdovi pristižu.',
  'Top Traders This Week': 'Najbolji trejderi ove nedelje',
  'Top Traders This Month': 'Najbolji trejderi ovog meseca',
  'View full leaderboard': 'Pogledaj celu rang listu',
};
